import { Box, Button, Container, Divider, Typography } from "@mui/material";
import React from "react";
import Slider from "react-slick";

import NorthEastIcon from "@mui/icons-material/NorthEast";
import { ThemeContext } from "@emotion/react";
import { COLORS } from "../constants/constants";
interface ServicesProps {
  handleOpenBooking: (serviceId: string) => void;
}

const Services: React.FC<ServicesProps> = (props) => {
  const slickSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const services = [
    {
      title: "Mua - Bán",
      description:
        "Thu mua máy cũ. Bán máy mới chính hãng + giá kho. Thu cũ - đổi mới máy lạnh.",
      image: "/images/s1.png",
      callToAction: "Gọi ngay",
      icon: NorthEastIcon,
    },
    {
      title: "Thi Công Lắp Đặt",
      description:
        "Nhận lắp đặt các loại máy treo tường, âm trần, tủ đứng, máy lạnh trung tâm,...",
      image: "/images/s2.png",
      callToAction: "Đặt lịch",
      icon: NorthEastIcon,
    },
    {
      title: "Vệ Sinh",
      description:
        "Nhận vệ sinh các loại máy treo tường, âm trần, tủ đứng, máy lạnh trung tâm,... hộ gia đình, cao ốc văn phòng, nhà máy...",
      image: "/images/s3.png",
      callToAction: "Đặt lịch",
      icon: NorthEastIcon,
    },
    {
      title: "Sửa Chữa",
      description:
        "Nhận sửa chữa các loại máy treo tường, âm trần, tủ đứng, máy lạnh trung tâm,...hộ gia đình, cao ốc văn phòng, nhà máy...",
      image: "/images/s4.png",
      callToAction: "Đặt lịch",
      icon: NorthEastIcon,
    },
    {
      title: "Di dời",
      description:
        "Nhận tháo lắp di dời các loại máy treo tường, âm trần, tủ đứng, máy lạnh trung tâm,...hộ gia đình, cao ốc văn phòng, nhà máy...",
      image: "/images/s5.png",
      callToAction: "Đặt lịch",
      icon: NorthEastIcon,
    },
  ];
  return (
    <section id="services" className="py-10">
      <Box className=" bg-white">
        <Container maxWidth="lg" className="w-full mx-auto">
          <Container className="flex flex-col lg:flex-row items-center w-full">
            {/* For PC */}
            <Typography
              variant="h4"
              align="left"
              style={{ whiteSpace: "pre-line" }}
              className="hidden lg:block !w-1/2  !font-black text-gray-600"
            >
              {" Chúng tôi luôn cung \ncấp dịch vụ tốt nhất"}
            </Typography>

            {/* For Mobile */}
            <Typography
              align="left"
              style={{ whiteSpace: "pre-line" }}
              className=" w-full lg:hidden  !text-lg !font-black text-gray-600"
            >
              {" Chúng tôi luôn cung cấp dịch vụ tốt nhất"}
            </Typography>

            <Container className="lg:!w-1/2 !p-0">
              <Typography
                variant="h6"
                align="left"
                className="hidden lg:block mb-12 text-gray-600  !font-bold"
              >
                Dịch vụ
              </Typography>
              <Typography
                variant="subtitle1"
                align="left"
                className="mb-12 text-gray-600 "
              >
                Nhận hợp đồng cung cấp máy chính hãng - giá kho, thi công lắp
                đặt - bảo trì hệ thống máy lạnh trung tâm/ ống gió/ âm trần
                trong kho xưởng, tòa nhà văn phòng, trung tâm thương mại, chung
                cư, siêu thị, bệnh viện,... tại TP.HCM và các tỉnh thành khác.
              </Typography>
            </Container>
          </Container>
          <Divider className="!py-4" />
          <Slider {...slickSettings} className="!py-4">
            {services.map((service, index) => (
              <div key={index} className="w-[370px]">
                <div className="max-w-sm !m-2 !p-4  bg-white">
                  <div className="rounded-xl overflow-hidden mb-4">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-48 object-cover"
                    />
                  </div>
                  <h2 className="text-lg font-semibold mb-1">
                    {service.title}
                  </h2>
                  <p className="text-sm text-gray-600 mb-4 h-[68px]">
                    {service.description}
                  </p>
                  <button
                    className="inline-flex items-center gap-1 text-sm font-medium text-black px-4 py-2 border rounded-lg hover:bg-primary_blue hover:text-white transition"
                    onClick={() => props.handleOpenBooking(service.title)}
                  >
                    {service.callToAction}
                    <service.icon fontSize="small" />
                  </button>
                </div>
              </div>
            ))}
          </Slider>

          <Container className="flex flex-col lg:flex-row items-center w-full ">
            <div className=" w-full lg:w-1/2 text-left">
              <Typography
                sx={{
                  fontSize: {
                    xs: "16px",
                    lg: "24px",
                  },
                }}
                className="pb-3 text-gray-600  !font-medium"
              >
                Dịch vụ máy lạnh giá cả phải chăng
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "20px",
                    lg: "34px",
                  },
                }}
                className="pb-4  text-gray-600  !font-black"
              >
                Dịch vụ chất lượng cao và thân thiện với giá cả hợp lý
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "16px",
                    lg: "24px",
                  },
                }}
                className="pb-6  !font-thin text-gray-600"
              >
                Chúng tôi cung cấp tất cả các dịch vụ máy lạnh toàn diện theo
                nhu cầu của bạn.
              </Typography>
              <Box className="flex gap-4 pb-6">
                <Button
                  className=" !text-base !bg-primary_blue !text-white !px-4 !py-2"
                  variant="contained"
                  color="success"
                  onClick={() => props.handleOpenBooking("")}
                  sx={{
                    color: "#4D4D4D",
                    textTransform: "none",
                    backgroundColor: COLORS.primary_blue,
                    "&:hover": {
                      color: COLORS.primary_blue,
                    },
                  }}
                >
                  Đặt lịch ngay
                </Button>
              </Box>
            </div>
            <div className=" hidden lg:block flex-1 relative w-full flex justify-end">
              <div className="rounded-[2rem] border-t-[6px] border-r-[6px] border-primary_blue overflow-hidden w-[280px] lg:w-[320px] h-auto z-10">
                <img
                  src="/images/vs-vuong.png"
                  alt="Thợ vệ sinh máy lạnh"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="absolute bottom-[-80px] left-[10px] lg:left-[130px] w-[265px] border-t-[6px] border-r-[6px] border-white rounded-2xl overflow-hidden shadow-lg z-20">
                <img
                  src="/images/sua-vuong.png"
                  alt="Thợ kỹ thuật"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </Container>
        </Container>
      </Box>
    </section>
  );
};

export default Services;
